<template>
  <div>
    <h1>This feature is only available to Registered Users.</h1>
    <p>Registration is easy and free. Simply go to the <v-btn to="/signup" color="primary">Sign Up</v-btn> Page to create an account.</p>
    <p>If you're an existing user, please to the <v-btn to="/signin" color="primary">Sign In</v-btn> Page to continue.</p>
  </div>
</template>

<script>
  export default {
    name: 'SignUpRequired'
  }
</script>

<style scoped>
</style>